import { render, staticRenderFns } from "./how-oc-works-options.vue?vue&type=template&id=6087b4e9"
import script from "./how-oc-works-options.vue?vue&type=script&lang=js"
export * from "./how-oc-works-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports